module.exports = __webpack_public_path__ + "static/media/ic_head8.b8d3c052.png";